import script from "./MovieGroups.vue?vue&type=script&setup=true&lang=ts"
export * from "./MovieGroups.vue?vue&type=script&setup=true&lang=ts"

import "./MovieGroups.vue?vue&type=style&index=0&id=6e815c26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e815c26"]])

export default __exports__